/**
 * Debounces a request
 * 
 * @param {Function} callback 
 * @param {Number} timeout 
 * @returns 
 */
const debounce = function(callback, timeout = 300) {
    let timer = null

    return (...args) => {
        clearTimeout(timer)

        //run the callback after the defined time
        //unless the function is called again
        timer = setTimeout(() => {
            callback.apply(this, args)
        }, timeout)
    }
}

export default debounce
